import { BLACK } from '../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../theme/fontConstants';

/** Uppercase column labels (Status, Timekeeping, Department, etc.) on roster cards */
const rosterPropTextStyles = {
  fontFamily: PRIMARY_FONT[400],
  fontStyle: 'normal',
  fontSize: '14px',
  lineHeight: '16px',
  textTransform: 'uppercase',
  color: BLACK[60],
};

export default rosterPropTextStyles;
